export enum CapabilityAuditAreaEnum {
  Agreement = 0,
  TaskTypes = 1,
}
